import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AlertsService } from './alerts.service';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private loader: LoaderService,
    private http: HttpClient,
    private alertsService: AlertsService
  ) { }

  async get(url: string, title: string, options?: Options): Promise<ApiResponse | null> {
    if (options?.showLoader) { this.loader.show(); }

    try {
      return await this.http.get<any>(url).pipe(map((async (response: ApiResponse) => {
        if (options?.showLoader) { this.loader.hide(); }
        return await this.manageResponse(response, title);
      }))).toPromise();

    } catch (error) {
      if (options?.showLoader) { this.loader.hide(); }
      await this.manageError(error, title);
      return null;
    }
  }

  async post(url: string, payload: any, title: string, options?: Options): Promise<ApiResponse | null> {
    if (options?.showLoader) { this.loader.show(); }

    try {
      return await this.http.post<any>(url, payload).pipe(map(async (response: ApiResponse) => {
        if (options?.showLoader) { this.loader.hide(); }
        return await this.manageResponse(response, title);
      })).toPromise();

    } catch (error) {
      if (options?.showLoader) { this.loader.hide(); }
      await this.manageError(error, title);
      return null;
    }
  }

  async put(url: string, payload: any, title: string, options?: Options): Promise<ApiResponse | null> {
    if (options?.showLoader) { this.loader.show(); }

    try {
      return await this.http.put<any>(url, payload).pipe(map(async (response: ApiResponse) => {
        if (options?.showLoader) { this.loader.hide(); }
        return await this.manageResponse(response, title);
      })).toPromise();

    } catch (error) {
      if (options?.showLoader) { this.loader.hide(); }
      await this.manageError(error, title);
      return null;
    }
  }

  async delete(url: string, title: string, options?: Options): Promise<ApiResponse | null> {
    if (options?.showLoader) { this.loader.show(); }

    try {
      return await this.http.delete<any>(url).pipe(map((async (response: ApiResponse) => {
        if (options?.showLoader) { this.loader.hide(); }
        return await this.manageResponse(response, title);
      }))).toPromise();
      
    } catch (error) {
      if (options?.showLoader) { this.loader.hide(); }
      await this.manageError(error, title);
      return null;
    }
  }

  private async manageResponse(response: ApiResponse, title: string): Promise<ApiResponse | null> {
    if (response.success) {
      return response;
    } else {
      this.alertsService.error({
        title: title,
        content: response.error
      });
      return null;
    }
  }

  private async manageError(error: HttpErrorResponse, title: string): Promise<void> {
    if (error.error instanceof Error) {
      console.error('An error occured:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
    }
    const content = error.status === 401 ?
                    "Unauthorized" :
                    "An error occured while calling the API";

    this.alertsService.error({
        title: title,
        content: content
    });
  }
}

interface ApiResponse {
  success: boolean;
  [x: string]: any;
  error?: string;
}

interface Options {
  showLoader?: boolean;
}
